import React from 'react'
import { makeStyles } from '@mui/styles'

import { ShowHideAllWrapper } from 'components'
import SimpleEntry from './SimpleEntry'

import { navigation } from 'services/navigation'

import { FormattedMessage } from 'react-intl'
import intl from 'localization/components'

const useStyles = makeStyles((theme) => ({
  marginTop: {
    marginTop: '2rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
    },
  },
  invalid: {
    color: 'gray',
  },
  space: {
    marginLeft: '0.4rem',
  },
  text: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))

const Founders = ({ data, handleClick }) => {
  const classes = useStyles()
  const [isShowAll, setIsShowAll] = React.useState(false)
  return (
    <div style={{ marginBottom: data.length > 1 ? '1rem' : '' }}>
      <SimpleEntry
        title={<FormattedMessage id={intl.companyInfo('founders_auditors')} />}
        elementType="div"
        content={[
          data?.map((entry, i) => (
            <ShowHideAllWrapper
              setIsShowAll={setIsShowAll}
              isShowAll={isShowAll}
              key={i}
              amountOfShowedItems={3}
              iteration={i}
              dataLength={data?.length}
            >
              <div
                className={classes.text}
                onClick={(e) =>
                  handleClick(
                    e,
                    entry?.type === 'COMPANY'
                      ? navigation.creditCheck(entry?.local_organization_id)
                      : navigation.relationOverview({
                          country: entry?.country?.toLowerCase(),
                          id: entry?.personal_id,
                        })
                  )
                }
                style={{ display: 'flex' }}
              >
                {entry.name}
              </div>
            </ShowHideAllWrapper>
          )),
        ]}
      />
    </div>
  )
}

export default Founders
